var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',_vm._b({staticClass:"ma-1",attrs:{"large":_vm.large,"icon":"","title":!_vm.starred ? `Lisa lemmikuks` : `Eemalda lemmikutest`},on:{"click":_vm.onStarClick}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"large":_vm.large},domProps:{"textContent":_vm._s(`mdi-star${!_vm.starred ? '-outline' : ''}`)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }